import ReactGA from 'react-ga';

export function initializeAdTracking(path) {
  ReactGA.initialize('UA-153787915-1')
  ReactGA.pageview(path)
}
